import { Link } from '@material-ui/core';
import React, { useState } from 'react'
import './Abc.css'
import Product from "./Product";
import Table from "./Table";
import { useStateValue } from './StateProvider';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { db } from './firebase';
import { useHistory } from "react-router-dom";

function Abc() {
    const [{ basket, user }, dispatch] = useStateValue();
    

    const history = useHistory();
    // console.log('This is the basket >>> ', basket);
    const [startDate, setStartDate] = useState(new Date());

    const sendDateTime = (event) => {
        event.preventDefault();

        const elementsArray = [...event.target.elements];

        const formData = elementsArray.reduce((accumulator, currentValue) => {
            if (currentValue.id) {
                accumulator[currentValue.id] = currentValue.value;
            }

            return accumulator;
        }, {});

        db.collection('Timing').add(formData);
    }

    const addToBasket = (id, title, image, price) => {
        // dispatch the item into the data layer
        
        dispatch({
            type: 'ADD_TO_BASKET',
            item: {
                id: id,
                title: title,
                image: image,
            }
        })
    }
    return (
        <div className="abc">
            <meta name="viewport" content="width=100%"/>
            <h3 className="user__email">Hello, {user?.email}</h3>
            <div className="hotel_1_imgs">
                    <img className="htl_1_pht_1" src="/images/Photo-1.jpg"></img>
                    <img className="htl_1_pht_2" src="/images/Photo-2.jpg"></img>
                    <img className="htl_1_pht_3" src="/images/Photo-3.jpg"></img>
                    <img className="htl_1_pht_4" src="/images/Photo-4.jpg"></img>
            </div>
                
                <h2 className="htl_1_name">XYZ Restaurant</h2>
                <h3 className="htl_1_spc">Continental, Chinese, Punjabi</h3>
                <h3 className="htl_1_add">Dubai</h3>
                <h3 className="htl_1_bmt">Book My Table</h3>

            <div className="htl_1_tables">
                    
                    <Table 
                        id = "7534254"
                        title = "2 Person"
                        image = "images/dine-table(2).jpg"
                        price = {1}
                    />
                    
                    <Table 
                        id = "7534254"
                        title = "4 Person"
                        image = "images/dine-table(4).jpg"
                        price = {0}
                    />

                    <Table 
                        id = "8465436"
                        title = "6 Person"
                        image = "images/dine-table(6).jpg"
                        price = {0}
                    />
                    
                    <Table 
                        id = "8765489"
                        title = "8 Person"
                        image = "images/dine-table(8).jpg"
                        price = {0}
                    />
                </div>
                {/* <div className="htl_1_tables">
                    <Table
                        id = "5432456"
                        title = "2 Person"
                        image = "images/dine-table(2).jpg"
                        price = {0}
                    />

                    <Table 
                        id = "98756456"
                        title = "4 Person"
                        image = "images/dine-table(4).jpg"
                        price = {0}
                    />

                    <Table 
                        id = "98756456"
                        title = "4 Person"
                        image = "images/dine-table(4).jpg"
                        price = {0}
                    />

                    <Table 
                        id = "98756456"
                        title = "2 Person"
                        image = "images/dine-table(2).jpg"
                        price = {0}
                    />
                </div>  */}
                {/* <div className="htl_1_tables">
                    <Table 
                        id = "98756456"
                        title = "6 Person"
                        image = "images/dine-table(6).jpg"
                        price = {0}
                    />

                    <Table 
                        id = "98756456"
                        title = "6 Person"
                        image = "images/dine-table(6).jpg"
                        price = {0}
                    />

                    <Table 
                        id = "98756456"
                        title = "6 Person"
                        image = "images/dine-table(6).jpg"
                        price = {0}
                    />

                    <Table 
                        id = "98756456"
                        title = "6 Person"
                        image = "images/dine-table(6).jpg"
                        price = {0}
                    />
                </div>    */}
            
            <p className="menu">Menu</p>
            <div className="abc__column">
                <Product 
                    id="12344321"
                    title="Manchurian"
                    price={180}
                    image="images/Manchurian.png"
                />

                <Product 
                    id="98766789"
                    title="Soup"
                    price={160}
                    image="images/Soup.png"
                />

                <Product 
                    id="5342526"
                    title="Cheese Balls"
                    price={140}
                    image="images/Cheese Balls.png"
                />

            </div>

            <div className='abc__column'>
            <Product 
                    id="4324565"
                    title="Mutter Paneer"
                    price={200}
                    image="images/Mutter Paneer.jpg"
            />
            </div>
            
        </div>
    )
}

export default Abc
